import React from 'react';
import styled from 'styled-components';

import { Row, Col, Container } from '../Grid';
import hamburger from './hamburger.png';
import hamburger2x from './hamburger2x.png';
import { boxShadow } from '../lib/styles/helpers';

export const headerHeight = 60;

const Wrapper = styled.header`
  background-color: #6633cc;
  ${boxShadow}
  color: #fff;
  height: ${headerHeight}px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
`;
const IconContainer = styled.div`
  align-items: center;
  display: inline-flex;
  height: ${headerHeight}px;
  line-height: ${headerHeight}px;
  margin-right: 2em;
  vertical-align: top;
  width: 24px;
`;
const Icon = styled.img`
  height: 24px;
  vertical-align: text-bottom;
  width: 24px;
`;
const Title = styled.h1`
  display: inline-block;
  font-size: 20px;
  font-weight: normal;
  letter-spacing: -0.005em;
  line-height: ${headerHeight}px;
  margin: 0;
`;

const Header = () => {
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <IconContainer>
              <Icon src={hamburger} srcSet={`${hamburger2x} 2x`} alt="Menu Icon" />
            </IconContainer>
            <Title>Messages</Title>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/Header/index.js